module.exports = __webpack_public_path__ + "img/483c853.svg";